import { selector } from 'recoil';
import { allCoverablesAtom } from '../atoms/allCoverablesAtom';
import { allCoverablesToCoverableDTOArray } from '../../utils/coverablesUtil';
import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { currentCoverableIdAtom } from '../atoms/currentCoverableIdAtom';

export const currentCoverableSelector = selector<CoverableDTO | undefined>({
    key: 'currentCoverableSelector',
    get: ({ get }) => {
        const allCoverables = get(allCoverablesAtom);
        const coverableList = allCoverablesToCoverableDTOArray(allCoverables);
        const currentCoverableId = get(currentCoverableIdAtom);
        const currentCoverable = coverableList.find(
            (coverable) =>
                coverable.fixedId === currentCoverableId.fixedId &&
                coverable.lobCode === currentCoverableId.lobCode
        );

        return currentCoverable;
    }
});
